// var $ = require('commonjs/zepto');

require('commonjs/zepto.mpopup.v2');
var login = require('mmd.common.pop_login').init();

// loading
var opt = {
  type : 'loading',
  content : '',
  icoType : '',
  mask: true
};
// 领取成功 对勾
var opt2 ={
  type : 'info',
  content : '',
  icoType : 'right',
  autoClose: 3000,
  mask: true
};
// 叹号
var opt3 = {
  type : 'info',
  content : '',
  icoType : 'info',
  mask: true,
  autoClose: 3000,
};

// error
var opt4 = {
  type : 'info',
  content : '',
  icoType : 'error',
  autoClose: 3000,
  mask: true,
};

//loading
var oLoad = $.mpopup(opt);

// //成功
var oSuccess = $.mpopup(opt2);

//  已领取  叹号
var oWarn = $.mpopup(opt3);

//  其他统一提示领取失败，请稍后再试！  叉号
var oFail = $.mpopup(opt4);

var couponActiveClassName = 'coupon__item--active';
var couponReceivedClassName = 'coupon__item--received';

// 领取优惠券
function getCoupon(e,callback) {
  let $this = $(this);
  let obtainId = $this.data('obtain-id');
  let btnDes = '已领取';

  if ($this.data('click') == 0) {
    $this.data('click', 1)
  } else {
    return;
  }

  
  login.start(function(){
    oLoad.show();
    $.ajax({
      type: 'GET',
      url: '/coupon/get_user_coupon',
      dataType: "json",
      data: {
        obtainId: obtainId
      },
      error: function () {
        oLoad.close();
        oFail.setContent('领取失败，请稍后再试！').show();
      },
      success: function(response) {
        oLoad.close();

        if (response.errcode == 0) {
          if ($this.hasClass(couponActiveClassName)) {
            $this.removeClass(couponActiveClassName);
          }
          if (!$this.hasClass(couponReceivedClassName)) {
            $this.addClass(couponReceivedClassName);
          }
          oSuccess.setContent('领取成功!<br/>请在个人中心-我的优惠券查看').show();
          $this.find(".coupon__status span").html(btnDes);
          $this.find(".coupon__status a").show();
        }else if(response.errcode == 0x20BA1023){
          if ($this.hasClass(couponActiveClassName)) {
            $this.removeClass(couponActiveClassName);
          }
          if (!$this.hasClass(couponReceivedClassName)) {
            $this.addClass(couponReceivedClassName);
          }
          // loading
          oWarn.setContent('你已领取！').show();
          $this.find(".coupon__status span").html(btnDes);
        }else if(response.errcode == 0x20BA1036){
          oWarn.setContent('已结束发放，下次请早哦！').show();
          $this.find(".coupon__status span").html("");
          $this.append(`<div class="mc_modal_over" style="display: block;">
            <p class="mc_modal_tips">已抢光</p>
          </div>`);
        }else if(response.errcode == 549064752 || response.errcode == 549064759){
          $this.hide();//已过期的券  隐藏
          // loading
          oWarn.setContent('已结束发放，下次请早哦！').show();
          $this.find(".coupon__status span").html("");
          $this.append(`<div class="mc_modal_over" style="display: block;">
            <p class="mc_modal_tips">已抢光</p>
          </div>`);
        }else if(response.errcode == "539299862"||response.errcode == "539299865"){
          location.href = '//' + location.host + "/mlogin/check_user?rurl="+ encodeURIComponent(location.href);

        }else if(response.errcode == 549068803) {
          oWarn.setContent('啊哦，您当前不是付费会员哦~').show();
        }else if(response.errcode == 549068804) {
          var buttons = [
            {tpl: '<a class="mod_popup_btn" href="/">去升级</a>'}, // todo 跳转链接
            {tpl: '<a class="mod_popup_btn" data-mpopup-close href="javascript:void(0)">我知道了</a>'}
          ];
          $.mpopup({
            type: 'confirmV2',
            content: '<div style="text-align: center">您当前等级不满足领取条件，快去升级吧~</div>',
            destroyAfterClose: true,
            buttons: buttons
          }).show();
        }else {
          oFail.setContent('领取失败:'+(response.errmsg ? response.errmsg : '请稍后再试~')).show();
        }
      }
    })
  })
}

module.exports = {
  oLoad: oLoad,
  oFail: oFail,
  oWarn: oWarn,
  oSuccess: oSuccess,
  getCoupon: getCoupon
}


// WEBPACK FOOTER //
// ./module/coupon_common.js